import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const FORM_SERVICE_CONTEXT_SYMBOL = Symbol();
const useFormService = ()=>useImmutableContext(FORM_SERVICE_CONTEXT_SYMBOL);
const useFormServiceProvider = (...args)=>useImmutableContextProvider(FORM_SERVICE_CONTEXT_SYMBOL, ...args);
export { useFormService, useFormServiceProvider };
